import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import type { MyCaseStatistics } from '../../types/dashboard'
import { Breakdowns, StateMessage, StatsGrid, Welcome } from './summary-view/summary-view.parts'

interface SummaryViewProps {
  statistics: MyCaseStatistics | null
  loading?: boolean
  userName?: string
}

export function SummaryView({
  statistics,
  loading = false,
  userName,
}: SummaryViewProps): ReactElement {
  const { t } = useTranslation('admin')

  if (loading) return <StateMessage message={t('summary.loadingStatistics')} spinner />
  if (!statistics) return <StateMessage message={t('summary.noStatistics')} />

  return (
    <div className="space-y-6">
      {userName && <Welcome userName={userName} t={t} />}
      <StatsGrid statistics={statistics} t={t} />
      <Breakdowns statistics={statistics} t={t} />
    </div>
  )
}
